/*
Sohel 02/15/2023 2701350359 Batch Triggers Basic info Changes
Ravi 02/20/2023 2701350359 fixed validation issue in code
Raghu 02/23/2023 2701350359 fixed new Ui changes
Raghu 02/228/2023 2701350359 fixed input alignmnets
Raghu 03/01/2023 2701350359 fixed input alignmnets
Ravi 03/01/2023 2701350359 Rename validation Disposition to Status
Sohel 03/02/2023 2698811066 fixed validation issue
sohel 03/06/2023 2698811066 Added validation message for existing value
Suresh Peddavoora 03/23/2023 2698811066 Fixed textfield label shrink issue
Guru Prasad 03/23/2023 2698811066 Fixed card styling issues
Sohel 03/29/2023 2698811066 FIxed Validation Issue
Sohel 04/04/2023 2698811066 FIxed Action Validation Issue
Ravi 04/04/2023 2698811066 FIxed Validation Issue in filter Method
Sohel 04/05/2022 2692790263 FIxed Filter Method Validation issue
Akhila 05/31/2023 2692790263 unsaved changes bug fixed
Akhila 06/20/2023 2692790263 modified account by list date action and field implemented Today or T
Sohel 06/21/2023 2692790263 Disabled Save and Save Next Button
Akhila 06/21/2023 2692790263 conditionally disable save and finish button on submission
Bhuvan 12/11/2023 2692790263 Changed validation for Batch trigger code and batch trigger description
Sohel 12/11/2023 2692790263 Last Step Payload Changes
*/
import {Button, TextField, FormHelperText, MenuItem} from '@material-ui/core';
import React, {useEffect, useState, useContext, useRef} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {
  getFieldCode,
  getActions,
  postFieldCode,
} from '../../../../../redux/reducers/BRE/AddReportMaster';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import * as yup from 'yup';
import {
  getCollectorsData,
  getClientCodeData,
  getDropDownData,
} from '../../../../../redux/reducers/BRE/AddReportMaster';
import {
  fetchAllGroupCode,
  fetchTriggerGroup,
  postTriggerGroup,
  resetMessage,
} from '../../../../../redux/reducers/TriggerGroup';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import GetAccessMethodFields from '../../../ReportMaster/SearchReportMaster/GetAccessMethodFields';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
const modeOptions = [{value: 'Test'}, {value: 'Update'}];

const BasicInfo = ({
  reportDialogData,
  rowData,
  setTabValue,
  value,
  handleTabChange,
  activeStep,
  handleNext,
  handleBack,
  handleDirty,
  rowSelected,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [codePopover, setCodePopover] = useState(false);
  const [triggerCodesData, setTriggerCodesData] = useState();
  const [fieldSubmitted, setSubmitted] = useState(false);
  const formRef = useRef();
  const codeRef = useRef();
  const saveRef = useRef();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Batch Triggers']?.BT;
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option || item.key === option || item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const getValue = (values) => {
    const a = values?.split(' ')?.join('');
    const dateValue = values?.length > 1 ? values?.slice(0, 5) :'';
    if (dateValue?.toUpperCase() === 'TODAY') {
      return a?.replace(dateValue, 'cast(now()as date)');
    } else if (values?.charAt(0)?.toUpperCase() === 'T') {
      return a?.replace(values?.charAt(0), 'cast(now()as date)');
    } else {
      return values;
    }
  };
  const {
    addTriggerGroupStatus,
    isLoading: loading,
    successMsg,
    errorMsg,
    triggerGroupData,
    allGroupCode,
    batchTriggerId,
    isBatchTriggersDraft,
  } = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {isLoading, promptData, fieldCodeData, actionData} = useSelector(
    ({addReportMaster}) => addReportMaster,
  );
  const filteredfieldCodeData = fieldCodeData.filter((each) => each.fieldCode != 'DBUDWFIELDS');

  const initialValues = {
    action: triggerGroupData?.accessMethodInfo?.action ?
      triggerGroupData?.accessMethodInfo?.action :
      actionData ?
        actionData[0] :
        '',
    groupCode: triggerGroupData?.groupCode ? triggerGroupData?.groupCode : '',
    description:
      triggerGroupData && triggerGroupData?.groupDescription ?
        triggerGroupData?.groupDescription :
        '',
    accessMethod:
      triggerGroupData && triggerGroupData?.accessMethodInfo?.accessMethod ?
        getObject(triggerGroupData?.accessMethodInfo?.accessMethod, fieldCodeData) :
        null,

    mode: triggerGroupData?.mode ? getObject(triggerGroupData?.mode, modeOptions) : '',
  };
  const [initialVal, setInitialVal] = useState(initialValues);
  useEffect(() => {
    setInitialVal({...initialValues});
  }, [triggerGroupData]);


  // let initialValues = {
  //   accessMethod: rowData?.accessType ? getObject(rowData?.accessType, fieldCodeData) : "",
  //   action: actionData ? actionData[0] : "",
  //   mode: rowData?.mode ? getObject(rowData?.mode, modeOptions) : { value: "Test" },
  // };

  const [fieldCodeValue, setFieldCodeValue] = useState({});

  useEffect(() => {
    // (triggerGroupData?.accessType) &&
    //   dispatch(
    //     getActions(
    //        triggerGroupData?.accessType
    //     )
    //   );

    if (triggerGroupData?.accessMethodInfo?.accessMethod) {
      dispatch(getActions(triggerGroupData?.accessMethodInfo?.accessMethod));
      dispatch(
        postFieldCode({
          fieldCode: triggerGroupData?.accessMethodInfo?.accessMethod,
          options: triggerGroupData?.accessMethodInfo?.action,
        }),
      );
    }
  }, [triggerGroupData]);
  // useEffect(() => {
  //   rowData?.accessMethod?.fieldCode &&
  //             actionData && actionData.length > 0
  //             dispatch(
  //            postFieldCode({
  //           fieldCode: rowData?.accessType,
  //          options: actionData[0],
  //         })
  //        );
  // },[actionData])
  const getArrayData = (selectedAccessMethod, data) => {
    if (selectedAccessMethod === 'DBCOLLECTOR') {
      return data?.collectors && data?.collectors.length > 0 ?
        data.collectors.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSDISP') {
      return data?.disposition && data?.disposition.length > 0 ?
        data.disposition.map((i) => {
          return i.valueCode;
        }) :
        [];
    } else if (selectedAccessMethod === 'DBCLNT') {
      return data?.client && data?.client.length > 0 ?
        data.client.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSSTAT') {
      return data?.phase && data?.phase.length > 0 ? data.phase.map((i) => i?.valueCode) : [];
    } else {
      return [];
    }
  };
  const onSubmit = (data) => {
    dispatch(submissionStart());
    const client =
      triggerGroupData?.triggerGroupClientResponseList?.length > 0 ?
        triggerGroupData?.triggerGroupClientResponseList?.map((el) => {
          return {
            ...el,
            deletedGroupClientPhaseId: [0],
          };
        }) :
        [];
    const selectedAccessMethod = data?.accessMethod?.fieldCode;
    const singleData = data.Date;
    const payload = {
      accessMethodInfo: {
        accessMethod: data?.accessMethod?.fieldCode ? data?.accessMethod?.fieldCode : '',
        endDate:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
          data?.lastDate &&
          !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.lastDate)
            getValue(data?.lastDate) :
            '',
        action: data?.action ? data?.action : '',
        startDate:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
          singleData &&
          !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(singleData)
            getValue(data?.Date) :
            data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
              data?.startDate &&
              !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.startDate)
              getValue(data?.startDate) :
              '',
        value:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' ||
          ['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
            [] :
            getArrayData(selectedAccessMethod, data),
      },
      // accessType: data?.accessMethod?.fieldCode || "",
      triggerGroupId: triggerGroupData?.triggerGroupId || 0,
      deletedGroupClientId: [],
      groupCode: data?.groupCode || '',
      groupDescription: data?.description || '',
      isDraft: triggerGroupData?.isDraft ? triggerGroupData?.isDraft : 'Y',
      triggerGroupClientRequest: client,
      mode: data?.mode?.value ? data?.mode?.value : '',
      lastStep:
        isBatchTriggersDraft === 'N' ?
          triggerGroupData?.lastStep :
          saveRef.current && triggerGroupData?.lastStep ?
            triggerGroupData?.lastStep :
            1,
    };
    dispatch(postTriggerGroup(payload));
  };
  const checkGroupCodeExist = (value) => {
    if (allGroupCode && allGroupCode?.length > 0 && value) {
      const ar = [];
      allGroupCode.filter((i) => {
        if (
          i?.groupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkGroupCodeAlreadyExist = (value) => {
    if (allGroupCode && allGroupCode?.length > 0 && value) {
      const ar = [];
      allGroupCode.filter((i) => {
        if (
          i?.groupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const getTriggerCodesData = () => {
    if (allGroupCode && allGroupCode?.length > 0) {
      return allGroupCode?.filter(
        (i) => String(i?.groupCode?.toUpperCase())?.startsWith(triggerCodesData?.toUpperCase()) && i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };
  const validationSchema = yup.object().shape({
    groupCode: triggerGroupData?.groupCode ?
      null :
      yup
        .string()
        .required('Batch Trigger Name is required')
        .test(
          'groupCode',
          'Batch Trigger Name already exist',
          (value) => !checkGroupCodeExist(value),
        )
        .test(
          'groupCode',
          'Batch Trigger Name has already been used in the past',
          (value) => !checkGroupCodeAlreadyExist(value),
        ),
    description: yup.string().required('Batch Trigger Description is required'),
    mode: yup.mixed().test('mode', 'Mode is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    accessMethod: yup.mixed().test('accessMethod', 'Filter Method is required', (value) => {
      if (!value?.fieldCode) {
        return false;
      } else {
        return true;
      }
    }),
    disposition:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DSDISP' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) ?
        yup.array().test('dispo', 'Status is required', (val) => {
          if (val?.length) {
            return true;
          } else {
            return false;
          }
        }) :
        '',
    // .notOneOf(["none"], "Continue prev task failure is required")
    // .required("Disposition is required")
    // .nullable(),
    collectors:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBCOLLECTOR' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) ?
        yup.array().test('collector', 'Collector is required', (val) => {
          if (val?.length) {
            return true;
          } else {
            return false;
          }
        }) :
        '',
    phase:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DSSTAT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) ?
        yup.array().test('phase', 'Phase is required', (val) => {
          if (val?.length) {
            return true;
          } else {
            return false;
          }
        }) :
        '',
    client:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBCLNT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) ?
        yup.array().test('client', 'Client is required', (val) => {
          if (val?.length) {
            return true;
          } else {
            return false;
          }
        }) :
        '',
    Date:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['<', '>'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) ? // ? yup.date().typeError().nullable().required("Date is required")
        yup?.mixed().test('Date', 'Values is required', (val) => {
          if (val?.length) {
            return true;
          } else {
            return false;
          }
        }) :
        '',
    startDate:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) ? // ? yup.date().typeError().nullable().required("Start date is required")
        yup.mixed().test('startDate', 'From Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        '',
    lastDate:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) ? // ? yup
      //     .date()
      //     .typeError()
      //     .nullable()
      //     .required("End date is required")
      //     .min(yup.ref("startDate"), "End date should be greater than start date")
      // : "",
        yup.mixed().test('lastDate', 'To Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        '',
    action: yup.mixed().test('action', 'Action is Required', (val, ctx) => {
      if (!val && ctx.parent?.accessMethod?.fieldCode !== 'DBACCT') {
        return false;
      } else {
        return true;
      }
    }),
  });
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    if (addTriggerGroupStatus === 200 && successMsg) {
      setTimeout(() => {
        if (addTriggerGroupStatus === 200 && successMsg && !saveRef.current) {
          handleNext();
        }
        dispatch(resetMessage());
      }, 2500);
    }
  }, [addTriggerGroupStatus, successMsg]);

  useEffect(() => {
    dispatch(fetchAllGroupCode());
  }, []);
  useEffect(() => {
    if (batchTriggerId) {
      dispatch(fetchTriggerGroup(batchTriggerId));
    }
  }, [batchTriggerId]);
  useEffect(() => {
    dispatch(getFieldCode());
    dispatch(getCollectorsData());
    dispatch(getDropDownData());
    dispatch(getClientCodeData());
  }, []);

  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        initialTouched={{
          field: true,
        }}
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleBlur,
            errors,
            touched,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <Form autoComplete="off" noValidate>
                <div className="global-field-textfields new-standard-textfields mt-2">
                  <div className={`form-row`}>
                    {/* <div className={'col-sm-6 col-md-4 col-xl-4 form-group'}> */}
                    <div className={`col-sm-6 col-md-4 col-xl-3 ${errors.groupCode ? 'form-group-lg' : 'form-group'}`}>
                      <TextField
                        className={` ${classes.labelName}`}
                        placeholder={`Enter Batch Trigger Name`}
                        margin="dense"
                        name="groupCode"
                        variant="outlined"
                        value={values?.groupCode}
                        disabled={Boolean(triggerGroupData?.groupCode)}
                        label={`Batch Trigger Name`}
                        inputProps={{maxLength: 25}}
                        required
                        onBlur={handleBlur}
                        inputRef={codeRef}
                        onChange={(e) => {
                          setFieldValue('groupCode', e.target.value);
                          // let value = upperCaseCode(codeRef);
                          // setFieldValue("groupCode", value);
                          if (e.target.value) {
                            setCodePopover(true);
                            setTriggerCodesData(e.target.value);
                          } else if (e.target.value === '') {
                            setCodePopover(false);
                          }
                        }}
                        touched={touched.groupCode}
                        error={Boolean(errors.groupCode && touched.groupCode)}
                        fullWidth
                      />
                      <FormHelperText style={{color: 'red'}} variant="outlined">
                        {touched.groupCode && errors.groupCode}
                      </FormHelperText>
                      <div className="windowcode-popover Add-trigger-group-popover">
                        {codePopover &&
                          getTriggerCodesData()?.map((data, i) => (
                            <MenuItem key={i}>
                              {data?.groupCode?.replace(/ /g, '\u00a0')}
                            </MenuItem>
                          ))}
                      </div>
                    </div>
                    <div className={'col-sm-6 col-md-4 col-xl-4 form-group'}>
                      <TextField
                        className={` ${classes.labelName}`}
                        placeholder={`Enter Batch Trigger Description`}
                        margin="dense"
                        name="description"
                        variant="outlined"
                        value={values?.description}
                        label={`Batch Trigger Description`}
                        inputProps={{maxLength: 100}}
                        required
                        onBlur={handleBlur}
                        inputRef={codeRef}
                        onChange={(e) => {
                          setFieldValue('description', e.target.value);
                        }}
                        touched={touched.description}
                        error={Boolean(errors.description && touched.description)}
                        fullWidth
                      />
                      <FormHelperText style={{color: 'red'}} variant="outlined">
                        {touched.description && errors.description}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-6 col-md-4 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="mode"
                        id="mode"
                        size="small"
                        options={modeOptions}
                        required
                        value={values.mode}
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(_, data) => {
                          // handleChange(e);
                          // setFieldValue("mode", value);
                          setFieldValue('mode', data);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Mode"
                              placeholder="Select Mode"
                              required
                              error={touched.mode && errors.mode}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>{touched.mode && errors.mode && errors.mode} </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-md-4 col-xl-4 form-group `}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="accessMethod"
                        id="accessMethod"
                        size="small"
                        value={values?.accessMethod}
                        options={filteredfieldCodeData}
                        getOptionDisabled={(option) => option.valueCode === null}
                        getOptionLabel={(option) => {
                          return option && option?.description ? option?.description : '';
                        }}
                        required
                        onChange={(_, data) => {
                          setSubmitted(false);
                          setFieldCodeValue(data);
                          dispatch(getActions(data?.fieldCode));
                          if (['DBCLNT', 'DSSTAT', 'DBCOLLECTOR']?.includes(data.fieldCode)) {
                            setFieldValue('action', 'IN');
                            dispatch(
                              postFieldCode({
                                fieldCode: data.fieldCode,
                                options: 'IN',
                              }),
                            );
                          } else if (data.fieldCode === 'DBUDWFIELDS') {
                            setFieldValue('action', 'NOT IN');
                            dispatch(
                              postFieldCode({
                                fieldCode: data.fieldCode,
                                options: 'NOT IN',
                              }),
                            );
                          } else if (['DBLSTDTE', 'DSDISP ']?.includes(data.fieldCode)) {
                            setFieldValue('action', '<');
                            dispatch(
                              postFieldCode({
                                fieldCode: data.fieldCode,
                                options: '<',
                              }),
                            );
                          }
                          setFieldValue('accessMethod', data);
                        }}
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              fullWidth
                              margin="dense"
                              label="Filter Method"
                              name="accessMethod"
                              required
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              error={Boolean(touched.accessMethod && errors.accessMethod)}
                              placeholder="Select Filter Method"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText style={{color: 'red'}} variant="outlined">
                        {touched?.accessMethod && errors?.accessMethod && errors?.accessMethod}
                      </FormHelperText>
                    </div>
                    {values?.accessMethod?.fieldCode &&
                      values?.accessMethod?.fieldCode !== 'DBACCT' && (
                      <>
                        <div className="col-sm-6 col-md-2 col-lg-4 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="action"
                            id="action"
                            size="small"
                            value={values?.action}
                            options={actionData}
                            disabled={fieldCodeValue?.fieldCode === 'DBACCT'}
                            getOptionLabel={(option) => {
                              return option ? option : '';
                            }}
                            required
                            onChange={(_, data) => {
                              setFieldValue('action', data);
                              values?.accessMethod?.fieldCode &&
                                  data &&
                                  dispatch(
                                    postFieldCode({
                                      fieldCode: values?.accessMethod?.fieldCode,
                                      options: data,
                                    }),
                                  );
                            }}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  margin="dense"
                                  className={` ${classes.labelName} ${classes.actionField} `}
                                  {...params}
                                  variant="outlined"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  required
                                  error={Boolean(touched.action && errors.action)}
                                  fullWidth
                                  label="Action"
                                  name="action"
                                  placeholder="Select Action"
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched?.action && errors?.action && errors?.action}
                          </FormHelperText>
                        </div>
                        {values?.action && (
                          <div className="col-sm-6 col-md-6 col-lg-4 d-flex">
                            <GetAccessMethodFields
                              values={values}
                              formProps={props}
                              setFieldValue={setFieldValue}
                              accessMethodFields={promptData}
                              fieldCodeValue={fieldCodeValue}
                              additionalInfoData={triggerGroupData?.accessMethodInfo}
                              // fieldSubmitted={true}
                              fieldSubmitted={fieldSubmitted}
                              setSubmitted={setSubmitted}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <div className="row justify-content-center mb-2 new-standard-textfields disabled-button">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      disabled={activeStep === 0}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                    {/* {isBatchTriggersDraft === "N" && ( */}
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                      disabled={errorMsg || successMsg || isLoading || enabledSubmission ||(rowSelected && !roleDataDisable?.edit)}
                      onClick={() => {
                        saveRef.current = true;
                        handleDirty(false, 'fixed');
                        setSubmitted(true);
                        if (formRef.current.isValid) {
                          setSubmitted(false);
                        }
                      }}
                    >
                      Save
                    </Button>
                    {/* )} */}
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                      disabled={errorMsg || successMsg || isLoading || enabledSubmission || (rowSelected && !roleDataDisable?.edit)}
                      onClick={() => {
                        saveRef.current = false;
                        setSubmitted(true);
                        handleDirty(false, 'fixed');
                        if (formRef.current.isValid) {
                          setSubmitted(false);
                        }
                      }}
                    >
                      Save & Next
                    </Button>
                  </div>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {(isLoading || loading) && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default BasicInfo;
